<template>
  <v-card
    :class="`${inDarkMode ? '' : 'white nearblack--text'} elevation-0`"
    min-width="300px"
    max-width="450px"
    width="100%"
  >
    <v-col>
      <v-row
        :class="`${inDarkMode ? 'darkblue' : 'primary'} white--text font-weight-medium align-center pa-3`"
      >
        <v-col>
          <span class="px-1 header-2 font-weight-bold cursor-pointer">
            Release Brief
          </span>
        </v-col>

        <v-spacer />

        <!-- <v-col
          class="cursor-pointer text-right"
        >
          <v-icon
            class="white--text"
            @click="goToDocs"
          >
            open_in_new
          </v-icon>
        </v-col> -->
      </v-row>

      <v-row
        class="pa-6"
      >
        <v-col>
          <!-- <v-row class="body-2 mb-6">
            <span>
              iAdOps is committed to providing a secure and reliable platform for our users. Below are
              some of the latest security updates implemented to enhance the security of your account and data.
            </span>
          </v-row> -->

          <v-row class="pt-3">
            <v-col>
              <v-row class="font-weight-bold body-2">
                Security Center Rollout
              </v-row>

              <v-row :class="`${inDarkMode ? '' : 'nearblack--text'} caption font-weight-medium pt-1`">
                <p>
                  iAdOps is committed to providing a secure and reliable platform for our users.
                  We are excited to announce the general release of our new Security Center.
                </p>

                <p>
                  The iAdOps Security Center provides users with a centralized location to manage
                  their security settings and monitor their account activity. Organization and
                  enterprise admins can also manage their tenant's security settings, including
                  identity providers, SAML and OIDC configurations, and audit logs.
                </p>
              </v-row>

              <v-row class="font-weight-bold body-2">
                Request Early Access
              </v-row>

              <v-row :class="`${inDarkMode ? '' : 'nearblack--text'} caption font-weight-medium pt-1`">
                <p>
                  The Security Center is currently in beta. It will be rolled out to all relevant
                  users in the coming weeks. To opt-in early, <a
                    class="font-weight-bold"
                    href="mailto:tech@adops.com?subject=Security%20Center:%20Beta%20Invite"
                  >email tech@adops.com</a>
                  with the subject line <span class="font-weight-bold">"Security Center: Beta Invite"</span>.
                  Please include your first name, last name, iAdOps account email, and your organization's
                  business contact in the body of the email.
                </p>

                <p>
                  The Security Center is just one of the many steps we are taking to ensure the safety
                  and security of our users' accounts. More to come!
                </p>
              </v-row>

              <v-row class="font-weight-bold body-2">
                Security Questions?
              </v-row>

              <v-row :class="`${inDarkMode ? '' : 'nearblack--text'} caption font-weight-medium pt-1`">
                <p>
                  To report an issue or ask a question, please reach out to our
                  security team at <a
                    class="font-weight-bold"
                    href="mailto:security@adops.com"
                  >security@adops.com</a>.
                </p>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters: mapAuthGetters, mapState } = createNamespacedHelpers('auth')

export default {
  name: 'WelcomeCard',
  data() {
    return {
      dismissed: null,
    }
  },
  computed: {
    ...mapAuthGetters([
      'alert',
      'isInternalUser',
      'inDarkMode',
    ]),
    ...mapState({
      user: (state) => state.user,
    }),
  },
  methods: {
    goToDocs() {
      this.$router.push('/docs/releases')
      this.dismissFeaturePrompt()
    },
    async dismissFeaturePrompt() {
      this.dismissed = true

      const { user } = this
      const { email, personEmail, settings = {} } = user
      const alert = { dismissed: true }
      const doc = { settings: { ...settings, alert } }
      const docId = email || personEmail
      const data = { doc, docId }

      return this.$store.dispatch('auth/updateUserSettings', data)
    },
  },
}
</script>
